import { NavLink, Outlet } from 'react-router-dom';
import { C } from '../lib/theme.js';

/**
 * Settings — the admin workspace. Connections and Activity used to be their own
 * top-level nav items; they now live here as tabs (each its own nested route so
 * deep links + the back button keep working), mirroring the Studio tab pattern.
 */
const TABS = [
  { to: '/settings', end: true, label: 'General', hint: 'Theme, team, budget, requests' },
  { to: '/settings/connections', label: 'Connections', hint: 'Meta, Cloudbeds, Anthropic' },
  { to: '/settings/figures', label: 'Figures', hint: 'Statutory figures the Copy Engine quotes' },
  { to: '/settings/activity', label: 'Activity', hint: 'Audit log + sync runs' },
];

export function SettingsLayout() {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          gap: 2,
          padding: '0 30px',
          borderBottom: `1px solid ${C.lineSoft}`,
          background: C.base,
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            title={t.hint}
            style={{ textDecoration: 'none' }}
          >
            {({ isActive }) => (
              <div
                style={{
                  padding: '15px 16px 13px',
                  fontSize: 13.5,
                  fontWeight: 600,
                  color: isActive ? C.primary : C.muted,
                  borderBottom: `2px solid ${isActive ? C.basil : 'transparent'}`,
                  marginBottom: -1,
                  cursor: 'pointer',
                }}
              >
                {t.label}
              </div>
            )}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
